import { Navigate } from "react-router-dom";
import enums from "../../constants/enums";
import cookieStorage from "../../utilities/cookie_storage";

function RedirectIfAuthenticated({ children }) {
  const token = cookieStorage.getItem("token");
  const lastLoggedInAt = cookieStorage.getItem("lastLoggedInAt");
  const roleName = cookieStorage.getItem("roleName");
  const userType = cookieStorage.getItem("userType");
  const userCategory = cookieStorage.getItem("userCategory");
  const businessType = cookieStorage.getItem("businessType");

  if (token) {
    if (!lastLoggedInAt && roleName?.toLowerCase()?.includes("employee")) {
      return <Navigate to="/onboarding" replace />;
    }
    if (userType?.includes(enums?.CLIENT) && !(userCategory || businessType)) {
      return <Navigate to="/client-onboarding" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children || null;
}

export default RedirectIfAuthenticated;
